import React from 'react';

const LinkIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.4988 12.5002L12.4988 7.50023M9.16547 5.00023L9.5513 4.55357C10.3328 3.77217 11.3927 3.33323 12.4978 3.33331C13.603 3.33339 14.6628 3.77248 15.4442 4.55398C16.2256 5.33549 16.6646 6.39539 16.6645 7.50053C16.6644 8.60567 16.2253 9.66551 15.4438 10.4469L14.9988 10.8336M10.8322 15.0002L10.5013 15.4452C9.71069 16.2271 8.64364 16.6655 7.53173 16.6655C6.41983 16.6655 5.35278 16.2271 4.56215 15.4452C4.17245 15.0599 3.86306 14.6011 3.65191 14.0954C3.44076 13.5896 3.33203 13.047 3.33203 12.499C3.33203 11.9509 3.44076 11.4083 3.65191 10.9026C3.86306 10.3969 4.17245 9.93807 4.56215 9.55273L4.99882 9.1669",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
LinkIcon.displayName = "Icons.LinkIcon";

export { LinkIcon };
//# sourceMappingURL=LinkIcon.js.map
